import FadeInSection from '../../../components/feature/FadeInSection';

export default function GreetingMessageSection() {
  return (
    <section className="section-padding" style={{ background: '#fff' }}>
      <div className="content-width">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          {/* Photo */}
          <FadeInSection className="w-full lg:w-[340px] shrink-0">
            <div className="w-full h-[400px] lg:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/greeting-message.jpeg"
                alt="代表 坂本 - 縁結び和はは"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                width={340}
                height={460}
              />
            </div>
            <div className="mt-5 text-center">
              <p style={{ color: '#8b4513', fontSize: '13px', fontWeight: '600' }}>縁結び和はは 代表</p>
              <p style={{ color: '#4a3728', fontSize: '22px', fontWeight: '700', marginTop: '4px' }}>坂本　妙子</p>
            </div>
          </FadeInSection>

          {/* Message */}
          <FadeInSection className="flex-1">
            <h2
              style={{
                color: '#4a3728',
                fontSize: 'clamp(22px, 3vw, 30px)',
                fontWeight: '700',
                marginBottom: '28px',
                lineHeight: '1.6',
              }}
            >
              誰かと一緒にいる安心感を、<br />
              これからの人生にも。
            </h2>

            <div style={{ color: '#6b5a4e', fontSize: '16px', lineHeight: '2.1' }} className="space-y-5">
              <p>
                人生の中で、「もう一度、誰かと一緒に過ごしたい」そう思う瞬間は、誰にでも訪れるものだと思っています。
                けれど同時に、「今さら…」「どう動けばいいのかわからない」そんなお気持ちを抱えている方も、たくさんいらっしゃいます。
              </p>
              <p>
                私自身、多くの方と関わる中で、"本当は誰かと繋がりたいのに、一歩を踏み出せない"そんな方がとても多いことを感じてきました。
                だからこそ和ははでは、ただお相手を探すだけではなく、安心して一歩を踏み出せる場所でありたいと考えています。
              </p>
              <p>
                結婚相談所というと、少し堅く感じたり、ハードルが高く感じる方もいらっしゃるかもしれません。
                ですが和ははでは、お一人おひとりの気持ちに寄り添いながら、その方らしいペースでご縁をつないでいくことを大切にしています。
              </p>
              <p>
                これからの人生を、誰かと笑い合いながら過ごすこと。
                それは決して特別なことではなく、とても自然で、あたたかい選択だと思っています。
              </p>
            </div>

            <div
              className="mt-10 pt-8"
              style={{ borderTop: '1px solid #e8d8cc' }}
            >
              <p style={{ color: '#8b4513', fontSize: '15px', fontWeight: '600' }}>縁結び和はは 代表</p>
              <p
                style={{
                  color: '#4a3728',
                  fontSize: '26px',
                  fontWeight: '700',
                  marginTop: '6px',
                  fontFamily: 'Georgia, serif',
                }}
              >
                坂本　妙子
              </p>
            </div>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}
